'use strict';
(function() {
	angular
			.module('crewProfile')
			.component(
					'crewPaymentRatesComponent',
					{
						templateUrl : 'profile/components/crew-payment-rates-component.html',
						controller : function(CommonMasterData,
								crewProfileDTOFactory, CrewingSelectionHelper,
								AuthService, $scope, $http,
								EventManagerService, MessageService, $timeout,
								PopupManager) {
							var vm = this;

							vm.model = {
								isDisablePaymentEdit : true
							}

							EventManagerService
									.registerEventListener(
											EventManagerService.EVENT.CREW_PAYMENT_RATES.DELETE_RANGE,
											onDeleteRangeListener);
							EventManagerService
									.registerEventListener(
											EventManagerService.EVENT.CREW_PAYMENT_RATES.SAVE_RANGE,
											onSaveRangeListener);
							EventManagerService
									.registerEventListener(
											EventManagerService.EVENT.CREW_PAYMENT_RATES.APPLY_RANGE,
											onApplyRangeListener);

							EventManagerService
									.registerEventListener(
											EventManagerService.EVENT.CREW_PAYMENT_RATES.REFRESH_OTHER_PAYMENT,
											refreshEditPanel);

							vm.units = [ {
								Unit : '/session',
								Value : '/session'
							}, {
								Unit : '/per fight',
								Value : '/per fight'
							}, {
								Unit : '/per hour',
								Value : '/per hour'
							}, {
								Unit : '/per year',
								Value : '/per year'
							}, {
                  Unit : '/per month',
                  Value : '/per month'
              }, {
                Unit : '/per day',
                Value : '/per day'
              }
              ];

							vm.selectedUnitSession = vm.units[0];
							vm.selectedUnitFlight = vm.units[1];
							vm.selectedUnitHour = vm.units[2];
							vm.selectedUnitYear = vm.units[3];
							vm.selectedUnitMonth = vm.units[4];
							vm.selectedUnitDay = vm.units[5];

							vm.openAddRangePopUp = function(index) {
								var param = (!!index || index == 0) ? vm.flyingRangeDetails[index]
										: null;
								var details = crewProfileDTOFactory
										.setFlyRangePaymentDetail(param);
								details.rowIndex = index;
								details.showDeleteButton = !!details.paymentHourRangeCrewId ? true
										: false;
								details.crewProfileId = vm.crewProfileId;

								PopupManager.openModal(
										'ADD_CREW_FLYING_HOURS_RANGE', details,
										function() {
										});
							}

							function onDeleteRangeListener(params) {
								vm.deleteFlyingHoursDetail({
									'param' : params
								});
							}

							function onCancelRangeListener() {
								vm.onCloseClick();
							}

							function refreshEditPanel(isRefresh){
								if (isRefresh) {
									vm.model.isDisablePaymentEdit = true;
								}
							}

							function onApplyRangeListener(params) {

								var isValidRangeName = true;
								angular
										.forEach(
												vm.flyingRangeDetails,
												function(data, index) {
													if (data.rangeTitle == params.rangeTitle
															&& params.rowIndex != index) {
														isValidRangeName = false;
													}
												});

								var isValidRangeHours = true;

								if (!!params.toHour
										&& params.toHour < params.fromHour)
									isValidRangeHours = false;

								if (isValidRangeName) {
									if (isValidRangeHours) {
										vm.saveFlyingHoursDetails({
											'param' : params
										});
									} else {
										MessageService
												.warning(MessageService.MESSAGES.PAYMENT_RATES.INVALID_RANGE_HOUR);
									}
								} else {
									MessageService
											.warning(MessageService.MESSAGES.PAYMENT_RATES.RANGE_NAME_EXISTS);
								}
							}

							vm.onCloseClick = function() {
								PopupManager
										.closeModal('ADD_FLYING_HOURS_RANGE');
							};

							vm.addLayoverRange = function() {
								var layOverDetails = {
									'layoverRateRange' : 0,
									'layoverRateRangeUnit' : '',
								};
								vm.otherPaymentDetails.layOverDetails
										.push(layOverDetails);
							}

							vm.deleteLayoverRange = function(index) {
								vm.otherPaymentDetails.layOverDetails.splice(
										index, 1);
							}

							vm.editOtherPaymentRateClick = function() {
								vm.saveOtherPaymentRates({
									'param' : vm.otherPaymentDetails
								});
							}

							function onSaveRangeListener() {
								vm.saveOtherPaymentRates({
									'param' : vm.otherPaymentDetails
								});
							}

						},
						bindings : {
							flyingRangeDetails : '=',
							otherPaymentDetails : '=',
							crewProfileId : '=',
							showOtherPaymentDetails : '=',
							showFlyingHourDetails : '=',
							saveOtherPaymentRates : '&',
							saveFlyingHoursDetails : '&',
							deleteFlyingHoursDetail : '&'
						}
					});
})();
